import React, { FC } from 'react';
import { Container, Nav, Navbar, Offcanvas } from 'react-bootstrap';
import { clHeaderMenu } from 'configs/clHeaderMenu';
import { GiHamburgerMenu } from 'react-icons/all';
import Resume from 'assets/files/ThienNhanResume.pdf';

export const ClHeaderMobile: FC = () => {
  return (
    <Navbar expand={false} className="cl-header">
      <Container
        fluid
        className="cl-header-mobile__container d-flex justify-content-end align-items-center"
      >
        <Navbar.Toggle
          aria-controls="offcanvasNavbar"
          className="cl-header-mobile__toggle"
        >
          <GiHamburgerMenu />
        </Navbar.Toggle>
        <Navbar.Offcanvas
          id="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel"
          placement="end"
          className="cl-header-mobile__items"
        >
          <Offcanvas.Header
            closeButton
            className="cl-header-mobile__header d-flex justify-content-end align-items-center"
          />
          <Offcanvas.Body className="cl-header-items__container cl-header-mobile__container d-flex flex-column justify-content-center align-items-center">
            <Nav>
              {clHeaderMenu.map((val, index) => (
                <Nav.Link
                  key={index}
                  href={`/${val.path}`}
                  className="cl-header-item"
                >
                  {val.label}
                </Nav.Link>
              ))}
              <button
                onClick={() => window.open(Resume, '_blank')}
                className="download-resume"
              >
                Download CV
              </button>
            </Nav>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
  );
};
